var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 119,
    viewBox: "0 0 143 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.593 82.576L132.233 73.5618V49.1902C132.233 48.9706 132.217 48.773 132.211 48.5832C132.127 47.6429 131.853 47.0738 131.428 47.0281C127.901 46.6486 125.884 60.9595 109.527 60.9595C99.6947 60.9595 96.2496 54.441 95.0632 49.2521C94.2806 45.8078 94.4847 42.9389 94.4847 42.9389C104.971 43.0749 116.408 40.0021 118.385 32.8468C119.168 29.9939 118.445 26.4958 115.572 22.2914C105.755 7.97261 86.3633 8.75503 86.3633 8.75503C85.6187 5.84195 83.2539 2.7234 83.2539 2.7234C80.9872 3.95311 78.3495 8.65701 78.3495 8.65701C78.1596 6.8741 77.6875 5.17494 75.9925 3.67178C74.2896 2.16228 72.5932 0 72.5932 0C62.3963 14.1212 66.7447 14.5006 71.4684 33.1439C71.7645 34.3041 71.9849 35.4121 72.1605 36.4742C74.7158 52.3862 63.5448 57.2198 49.5688 73.6393C34.9384 90.8332 45.7432 106.752 46.1613 107.344L46.1692 107.36C43.1421 105.477 34.9384 96.8365 35.5908 86.0693C35.9868 79.6266 40.1609 73.2837 45.3011 67.0686C45.3235 67.0307 45.355 66.9928 45.393 66.9468C54.7913 55.6106 67.3703 44.7298 66.1143 34.6613C62.9351 9.1897 29.3703 12.618 29.3703 12.618C35.035 15.8204 41.0656 32.3995 30.8752 44.6381C28.45 47.5512 25.2707 50.2147 21.8793 52.9238C10.9825 61.6125 -2.15101 70.7403 0.297951 89.8453C2.03092 103.33 14.686 111.349 26.0089 115.886C30.8989 117.851 36.1153 118.845 41.3854 118.845H111.512C103.907 109.405 89.2083 109.998 89.2083 109.998C100.265 102.373 101.102 87.8348 93.6105 76.4749C113.679 79.791 124.438 69.1376 129.184 59.7282V72.8252L118.469 82.5682C117.503 83.4407 116.949 84.6784 116.949 85.9824V114.794C116.949 117.04 118.765 118.846 121.008 118.846H138.94C141.183 118.846 143 117.04 143 114.794V85.9002C143 84.6483 142.491 83.4421 141.593 82.576ZM95.6712 24.1739C93.7926 24.1739 92.264 22.6486 92.264 20.774C92.264 18.9152 93.7926 17.3899 95.6712 17.3899C97.5422 17.3899 99.0627 18.9152 99.0627 20.774C99.0627 22.6486 97.5422 24.1739 95.6712 24.1739ZM126.211 83.9354C126.613 82.4402 127.731 81.2561 129.184 80.7489V84.558C129.184 85.3927 129.868 86.0676 130.712 86.0676C131.123 86.0676 131.511 85.908 131.785 85.6282C132.059 85.3626 132.233 84.9833 132.233 84.558V80.7489C133.678 81.2578 134.804 82.4402 135.214 83.9354C135.313 84.3225 135.366 84.7319 135.366 85.1413C135.366 87.7066 133.283 89.7854 130.712 89.7854C128.141 89.7854 126.058 87.7066 126.058 85.1413C126.058 84.7319 126.104 84.3211 126.211 83.9354Z",
    fill: "url(#paint0_linear_24_88)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3899 66.9477C49.6478 61.3129 58.2825 47.0162 51.0197 31.2798C43.7029 15.4261 29.3672 12.6173 29.3672 12.6173C29.3672 12.6173 62.9381 9.1874 66.1143 34.6558C67.3672 44.7307 54.7896 55.6054 45.3899 66.9477Z",
    fill: "url(#paint1_linear_24_88)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.387 32.8478L118.377 32.8573C114.542 13.2418 86.3665 8.75764 86.3665 8.75764C86.3665 8.75764 105.756 7.97363 115.57 22.2877C118.45 26.4921 119.171 29.9932 118.387 32.8478Z",
    fill: "url(#paint2_linear_24_88)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.998 85.8984V114.797C142.998 117.038 141.185 118.848 138.938 118.848H121.012C118.765 118.848 116.952 117.038 116.952 114.797C141.121 115.868 142.998 90.0395 142.998 85.8984Z",
    fill: "url(#paint3_linear_24_88)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2069 109.998C75.3825 117.259 51.0862 109.543 51.0862 109.543C104.034 117.348 93.6088 76.4746 93.6088 76.4746C101.1 87.8345 100.263 102.373 89.2069 109.998Z",
    fill: "url(#paint4_linear_24_88)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0632 49.2509C80.3694 42.9046 77.2583 32.784 77.0603 32.2988C77.3865 32.7539 84.4801 41.8046 94.4848 42.9378C94.4848 42.9378 94.279 45.8066 95.0632 49.2509Z",
    fill: "url(#paint5_linear_24_88)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3899 66.948C49.6478 61.3132 58.2825 47.0165 51.0197 31.2815C43.7029 15.428 29.3672 12.6193 29.3672 12.6193C29.3672 12.6193 62.9381 9.18935 66.1143 34.6578C67.3672 44.731 54.7913 55.6057 45.3899 66.948Z",
    fill: "url(#paint6_linear_24_88)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.387 32.8478L118.377 32.8573C114.542 13.2418 86.3665 8.75764 86.3665 8.75764C86.3665 8.75764 105.756 7.97363 115.57 22.2877C118.45 26.4921 119.173 29.9932 118.387 32.8478Z",
    fill: "url(#paint7_linear_24_88)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M143 85.8984V114.797C143 117.038 141.186 118.848 138.94 118.848H121.013C118.767 118.848 116.953 117.038 116.953 114.797C141.123 115.868 143 90.0395 143 85.8984Z",
    fill: "url(#paint8_linear_24_88)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24_88",
    x1: -5.16565,
    y1: 2.61718,
    x2: 151.567,
    y2: 144.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#02B1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#0673CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#084DB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24_88",
    x1: 12.8738,
    y1: -4.9044,
    x2: 88.1038,
    y2: 88.0895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#00C5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#01BAF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#02A7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#048CD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#0669C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#084DB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24_88",
    x1: 66.1814,
    y1: -19.0119,
    x2: 135.631,
    y2: 49.5182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#00C5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#01BAF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#02A7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#048CD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#0669C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#084DB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_24_88",
    x1: 70.3024,
    y1: 56.4126,
    x2: 143.948,
    y2: 112.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#02B1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#0673CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#084DB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_24_88",
    x1: -30.3135,
    y1: 26.2577,
    x2: 136.13,
    y2: 134.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    stopColor: "#0393DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#084DB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_24_88",
    x1: 7.21613,
    y1: -10.4609,
    x2: 127.055,
    y2: 67.7998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    stopColor: "#0393DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#084DB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_24_88",
    x1: 12.8747,
    y1: -4.9039,
    x2: 88.1043,
    y2: 88.0899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#00C5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#01BAF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#02A7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#048CD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#0669C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#084DB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_24_88",
    x1: 66.1822,
    y1: -19.0116,
    x2: 135.631,
    y2: 49.5185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#00C5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#01BAF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#02A7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#048CD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#0669C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#084DB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_24_88",
    x1: 70.3033,
    y1: 56.4132,
    x2: 143.949,
    y2: 112.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#02B1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#0673CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#084DB4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f33f332e9461d494451a63a84c91a856.svg";
export { ForwardRef as ReactComponent };